"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const accounts_1 = require("companion-app-components/flux/accounts");
const DownshiftField_1 = __importDefault(require("components/QuickenControls/DownshiftField"));
const ReadOnlyField_1 = __importDefault(require("components/Transactions/ReadOnlyField"));
const AccountField = (_a) => {
    var { accounts: propAccounts, initialAccountId, onSelected, readOnly, className, doNotIncludeClosed } = _a, otherProps = __rest(_a, ["accounts", "initialAccountId", "onSelected", "readOnly", "className", "doNotIncludeClosed"]);
    const dispatch = (0, react_redux_1.useDispatch)();
    const accountsFromStore = (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getTransactionAccounts(state));
    const accountsLoadPending = (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getLoadPending(state));
    const accounts = propAccounts || accountsFromStore;
    const initialAccount = accounts === null || accounts === void 0 ? void 0 : accounts.get(initialAccountId || '');
    (0, react_1.useEffect)(() => {
        if (accountsLoadPending) {
            dispatch(accounts_1.accountsActions.getAccounts());
        }
    }, [accountsLoadPending, dispatch]);
    let sortedAccounts = accounts
        ? Array.from(accounts.values()).sort((accountOne, accountTwo) => accountOne.name.localeCompare(accountTwo.name, undefined, { numeric: true, sensitivity: 'base' }))
        : [];
    if (doNotIncludeClosed) {
        sortedAccounts = sortedAccounts.filter((account) => !account.isClosed);
    }
    if (readOnly) {
        return (<ReadOnlyField_1.default {...otherProps} label="Account" value={initialAccount ? initialAccount.name : 'Unknown'} className={className} sharedcomponentid="ACCOUNT_FIELD"/>);
    }
    return (<DownshiftField_1.default dataLoading={accountsLoadPending} items={sortedAccounts} initialItemSelected={initialAccount} onSelected={onSelected} textFieldProps={otherProps} itemToString={(account) => (account ? account.name : '')} itemKey={(account) => (account ? account.id : '')} indexId className={className}/>);
};
exports.default = AccountField;
